<a
    class="nav-link"
    [ngClass]="{ active: isActive, collapsed: collapsed, 'submenu-link': hierarchy.length > 0, 'nav-link--presta': isCreditos }"
    [attr.title]="isCreditos ? 'Fina Presta' : null"
    [attr.aria-current]="isCreditos && isActive ? 'page' : null"
    [hidden]="isItemHidden(sideNavItem)"
    (click)="toggle()"
    [attr.id]="sideNavItem?.tourId ? getTourElementId(sideNavItem.text) : null"
    [attr.data-tour]="sideNavItem?.dataTour || (sideNavItem?.tourId ? getTourElementId(sideNavItem.text) : null)"
    ><!-- Fina Presta (canvas «Box copy»): solo el logo, sin ícono; el nombre sigue en el DOM para lectores de pantalla -->
    <ng-container *ngIf="isCreditos; else featherIcon">
        <img class="nav-link-presta-logo" src="assets/img/creditos/fina-presta-light.png" alt="" height="18" data-test="presta-logo" />
    </ng-container>
    <ng-template #featherIcon>
        <div class="nav-link-icon" *ngIf="sideNavItem?.icon">
            <i-feather [name]="sideNavItem?.icon"></i-feather>
        </div>
    </ng-template>
    <span class="nav-link-label" [class.visually-hidden]="isCreditos" [title]="sideNavItem?.text">{{ sideNavItem?.text }}</span>
    <div class="badge badge-mora" [class.ms-auto]="isCreditos" [class.ms-2]="!isCreditos" *ngIf="sideNavItem.new && hasLateCredito">EN MORA</div>
    <div class="badge badge-new-violet" [class.ms-auto]="isCreditos" [class.ms-2]="!isCreditos" *ngIf="sideNavItem.new && !hasLateCredito">
        Nuevo<span class="badge-new-violet__emoji" *ngIf="!isCreditos"> 🎉</span>
    </div>
    <div class="badge bg-primary-soft text-primary ms-auto" *ngIf="sideNavItem.updated">Updated</div>
    <!-- Recaudos fiscal v2: estado del trámite de Facturación Digital en el ítem «Fiscal» -->
    <fina-fiscal-status-pill class="ms-auto" *ngIf="isFiscalItem && fiscalBadge" [pill]="fiscalBadge" [small]="true" data-test="fiscal-menu-badge"></fina-fiscal-status-pill>
    <span
        class="badge badge-count ms-auto"
        *ngIf="showCasheaLinkBadge"
        [attr.title]="casheaLinkReady === 1 ? '1 orden de Cashea Link lista para finalizar' : casheaLinkReady + ' órdenes de Cashea Link listas para finalizar'"
        data-test="cashea-link-ready-badge"
        >{{ casheaLinkReady > 99 ? '99+' : casheaLinkReady }}</span
    >
    <div class="sidenav-collapse-arrow" [class.ms-2]="showCasheaLinkBadge" *ngIf="sideNavItem?.submenu"><fa-icon class="ms-auto" [icon]="['fas', 'angle-down']"></fa-icon></div
></a>
<nav class="sidenav-menu-nested nav" [ngClass]="{ collapsed: collapsed }">
    <div class="sidenav-menu-nested__items">
        <sbpro-side-nav-item
            class="submenu"
            *ngFor="let submenuItem of sideNavItem?.submenu"
            [sideNavItem]="submenuItem"
            [ngClass]="{ collapsed: collapsed }"
            [hierarchy]="hierarchyExtension"
            [hidden]="hideTab(submenuItem)"
        >
        </sbpro-side-nav-item>
    </div>
</nav>
<!-- [routerLink]='sideNavItem.link', -->
